export default __webpack_public_path__ + "static/media/a011-startup-01.4bd52e09.svg";